import styled, { css } from "styled-components";

export const Container = styled.li`
  display: flex;
  width: 100%;
  height: 3rem;
  justify-content: space-between;
  align-items: center;
  cursor: default;
  padding: 0.3rem;
  border-radius: 6px;
  background-color: #f5f5f5;

  .info {
    display: flex;
    width: calc(100% - 3rem);
    justify-content: space-between;
    margin-left: 0.2rem;
  }

  span {
    display: flex;
    font-size: 15px;
    color: #4a4a4a;
    justify-content: center;
    align-items: center;
  }

  .actions {
    display: flex;
    align-items: center;
    height: 100%;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    outline: none;
    border: none;
    padding: 0.5rem;
    border-radius: 6px;
    border: 1px solid #1d86ff;
    color: #1d86ff;
    font-weight: 600;

    cursor: pointer;
  }

  ${({ isLoading }) =>
    isLoading &&
    css`
      & {
        pointer-events: none;
        user-select: none;
        opacity: 0.4;
      }
    `};
`;

export const Load = styled.div`
  border: 2px solid #c0bfbf;
  border-top: 2px solid black;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
